/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
/* eslint-disable quote-props */
/* eslint-disable comma-spacing */
/*
* gems/banco-rails-ui/client/lib/banco-ui/constants/shared.ts is automatically generated.
* DO NOT EDIT BY HAND.
* Regenerate it with: `REGENERATE_SPEC_FIXTURES=true bin/rspec` inside banco-rails-ui
*/

export const MinimumPasswordLength = 12;

export const OLDEST_SEARCH_DATE = new Date("2013-06-10T00:00");

export const API_COMPANY_NAME = "Silvercat";

export const MINIMUM_LTPP_MONTHLY_REPAYMENT = 20;
export const LTPP_BORDERLINE_TOTAL_DEBT_THRESHOLD = 30000;
export const LTPP_ELIGIBLE_TOTAL_DEBT_THRESHOLD = 20000;
export const STANDARD_FEE = 4200;
export const LONG_TERM_STANDARD_FEE = 4600;
export const LONG_TERM_STANDARD_FEE_MIN_MONTHS = 72;
export const PROOF_DOCUMENT_INCLUDE_ACCOUNT_MATCH_DETAILS =
  "account_match_details";

/***********************************************
*               FEATURE FLAGS                  *
***********************************************/

export type FeatureFlags = Record<string, boolean>;

export enum SettlementType {
  FULL = "Full",
  PARTIAL = "Partial"
}

export const PAYMENT_SERVICER_INFORMATION_UPDATE_TIME_FOR_CUSTOMERS = "15 minutes";

/***********************************************
*             LOAN APPLICATIONS                *
***********************************************/

export enum LoanApplicationPageView {
  LOAN_APPLICATIONS = "/loan_applications/:id",
  CANCEL = "/loan_applications/:id/cancel",
}

/***********************************************
*             LOAN ACCOUNTS                    *
***********************************************/

export enum AccountPageView {
  ACCOUNT = "/account",
  ADD_NEW_CARD = "/add_new_card",
  APPLICATION_HISTORY = "/account/application_history",
  MANAGE_LOAN = "/manage_loan",
  CHANGE_PAYMENT_DATE = "/account/change_payment_date",
  CONTACT_DETAILS = "/account/contact_details",
  DOCUMENTS = "/account/documents",
  MAKE_PAYMENT = "/make_payment",
  MANAGE_PAYMENT_DETAILS = "/account/manage_payment_details",
  PAYMENT_SUPPORT = "/account/payment_support",
  SETTLEMENTS = "/account/settlements",
  SERVICING_FAQ = "/servicing_faq",
  TRANSACTIONS = "/account/transactions",
  TOP_UPS = "/account/top_ups",
  PAYMENT_SCHEDULE = "/account/payment_schedule",
  PERSONAL_DETAILS = "/account/personal_details",
  ADDITIONAL_BORROWING = "/account/additional_borrowing",
  CONTACT_PREFERENCES = "/account/contact_preferences",
}

export enum LoanAccountPageView {
  LOAN_ACCOUNTS = "/loan_accounts/:id",
  MANAGE_PAYMENT_DETAILS = "/loan_accounts/:id/manage_payment_details",
  PAYMENT_SUPPORT = "/loan_accounts/:id/payment_support",
  CHANGE_PAYMENT_DATE = "/loan_accounts/:id/change_payment_date",
  CONTACT_DETAILS = "/loan_accounts/:id/contact_details",
  SETTLEMENTS = "/loan_accounts/:id/settlements",
  TRANSACTIONS = "/loan_accounts/:id/transactions",
  TOP_UPS = "/loan_accounts/:id/top_ups",
  PAYMENT_SCHEDULE = "/loan_accounts/:id/payment_schedule",
  PAYMENTS_NEW = "/loan_accounts/:id/payments/new",
  ADD_NEW_CARD = "/loan_accounts/:id/cards/new",
}

export enum AttachmentStatus {
  ATTACHED = "attached",
  DELETED = "deleted",
}
export enum LoanAccountStatus {
  CLOSED = "closed",
  OPEN = "open",
  PENDING_FUNDS_RELEASE = "pending_funds_release",
  PENDING_SETUP = "pending_setup",
}
export enum DocumentStatus {
  CANCELLED = "cancelled",
  DELETED = "deleted",
  NEW = "new",
}
export enum DocumentType {
  BANK_STATEMENT = "bank_statement",
  BENEFITS_LETTER = "benefits_letter",
  CHEQUE_BOOK = "cheque_book",
  CHILD_BENEFIT_LETTER = "child_benefit_letter",
  COUNCIL_BILL = "council_bill",
  CREDIT_CARD = "credit_card",
  DEED_POLL = "deed_poll",
  DRIVING_LICENCE = "driving_licence",
  HMRC_LETTER = "hmrc_letter",
  ID_CARD = "id_card",
  IMMIGRATION_SHARE_CODE = "immigration_share_code",
  IMMIGRATION_SHARE_CODE_DOC = "immigration_share_code_doc",
  MARRIAGE_CERTIFICATE = "marriage_certificate",
  ONFIDO_IDENTITY_DOCUMENT = "onfido_identity_document",
  OPEN_BANKING_REPORT = "open_banking_report",
  PASSPORT = "passport",
  PAYSLIP = "payslip",
  PENSION_LETTER = "pension_letter",
  PHONE_BILL = "phone_bill",
  RESIDENCY_PERMIT = "residency_permit",
  SELFIE = "selfie",
  STORE_CARD_BILL = "store_card_bill",
  TAX_RETURN = "tax_return",
  UNIVERSAL_CREDIT_STATEMENT = "universal_credit_statement",
  UTILITY_BILL = "utility_bill",
  VERIFICATION_EXCHANGE_PAYROLL = "verification_exchange_payroll",
  VIDEO_SELFIE = "video_selfie",
}
export enum FraudCaseAction {
  CONTINUE_AS_NORMAL = "continue_as_normal",
  EXTEND_RIGHT_TO_WITHDRAW = "extend_right_to_withdraw",
  LOAN_CLOSED_NO_LOSS = "loan_closed_no_loss",
  LOAN_CONTINUES = "loan_continues",
  LOAN_WRITTEN_OFF = "loan_written_off",
  REMOVE_1_PARTY = "remove_1_party",
  REPAY_PRINCIPAL_BALANCE = "repay_principal_balance",
}
export enum FraudCaseCategory {
  COERCION = "coercion",
  DEED_POLL_1ST_PARTY = "deed_poll_1st_party",
  EVASION_OF_PAYMENT_1ST_PARTY = "evasion_of_payment_1st_party",
  FALSE_DOCUMENTS_1ST_PARTY = "false_documents_1st_party",
  FAMILY_2ND_PARTY = "family_2nd_party",
  IDENTITY_THEFT_2ND_OR_3RD_PARTY = "identity_theft_2nd_or_3rd_party",
  MOBILE_THEFT = "mobile_theft",
  MONEY_MULE_1ST_PARTY = "money_mule_1st_party",
  OTHER = "other",
  SCAM_BITCOIN_INVESTMENT = "scam_bitcoin_investment",
  SCAM_CREDIT_SCORE_IMPROVEMENT = "scam_credit_score_improvement",
  SCAM_GET_RICH_QUICK_SCHEME = "scam_get_rich_quick_scheme",
  SCAM_INHERITANCE = "scam_inheritance",
  SCAM_INVESTMENT_NOT_BITCOIN = "scam_investment_not_bitcoin",
  SCAM_OTHER = "scam_other",
  SCAM_PHISHING = "scam_phishing",
  SCAM_RECRUITMENT = "scam_recruitment",
  SCAM_ROMANCE = "scam_romance",
  SCAM_VULNERABLE_CUSTOMER = "scam_vulnerable_customer",
}
export enum FraudCaseInvestigationOutcome {
  CONFIRMED_NOT_PAID_OUT = "confirmed_not_paid_out",
  CONFIRMED_PAID_OUT = "confirmed_paid_out",
  NOT_CONFIRMED = "not_confirmed",
  OPENED_IN_ERROR = "opened_in_error",
}
export enum LoanSaleExclusionCategory {
  ARRANGEMENT_AGREED = "arrangement_agreed",
  COMPLAINT_EXCLUSION = "complaint_exclusion",
  EXTREME_VULNERABILITY = "extreme_vulnerability",
  INCARCERATION = "incarceration",
  OTHER = "other",
  POTENTIAL_FRAUD = "potential_fraud",
  POTENTIAL_LITIGATION = "potential_litigation",
  SETTLEMENT_AGREED = "settlement_agreed",
}
export enum TaskStatus {
  APPROVED = "approved",
  AWAITING_OTHER_TASKS = "awaiting_other_tasks",
  DECLINED = "declined",
  IN_REVIEW = "in_review",
  INVALIDATED = "invalidated",
  NEEDS_ATTENTION = "needs_attention",
  PENDING = "pending",
  REQUIRED = "required",
}
export enum TaskType {
  ADDITIONAL_INFORMATION = "additional_information",
  ADDRESS_PROOF = "address_proof",
  BANK_ACCOUNT_PROOF = "bank_account_proof",
  BANK_STATEMENT_PROOF = "bank_statement_proof",
  CALL_REQUEST = "call_request",
  CARD_VALIDATION = "card_validation",
  DEBT_CONSOLIDATION = "debt_consolidation",
  E_SIGN = "e_sign",
  EMAIL_VALIDATION = "email_validation",
  ENHANCED_INCOME_PROOF = "enhanced_income_proof",
  FINANCIALS_PROOF = "financials_proof",
  IDENTITY_PROOF = "identity_proof",
  IMMIGRATION_SHARE_CODE_PROOF = "immigration_share_code_proof",
  INCOME_PROOF = "income_proof",
  INTERNAL_REVIEW = "internal_review",
  MOBILE_VALIDATION = "mobile_validation",
  OPEN_BANKING_REPORT_PROOF = "open_banking_report_proof",
  PAYSLIP_PROOF = "payslip_proof",
  PROOF_REQUEST = "proof_request",
  RESIDENCY_PROOF = "residency_proof",
  REVIEW_FLAGS = "review_flags",
  REVIEW_FRAUD = "review_fraud",
  REVIEW_KYC = "review_kyc",
  REVIEW_OPEN_BANKING_REFERRAL = "review_open_banking_referral",
  SELFIE_PROOF = "selfie_proof",
  UNDERWRITER_FINAL_REVIEW = "underwriter_final_review",
  VERBAL_CONFIRMATION = "verbal_confirmation",
  VERIFY_INCOME_DETAILS = "verify_income_details",
}
export enum CustomerVulnerability {
  ADDICTION = "addiction",
  BEREAVEMENT = "bereavement",
  DARK_SUICIDAL_THOUGHTS = "dark_suicidal_thoughts",
  DOMESTIC_VIOLENCE = "domestic_violence",
  FINANCIAL_VULNERABILITY = "financial_vulnerability",
  GAMBLING = "gambling",
  GENERAL_VULNERABILITY = "general_vulnerability",
  HOMELESSNESS = "homelessness",
  ILLNESS = "illness",
  INJURY = "injury",
  LANGUAGE_BARRIER = "language_barrier",
  MARRIAGE_OR_RELATIONSHIP_BREAKDOWN = "marriage_or_relationship_breakdown",
  MENTAL_HEALTH = "mental_health",
  NEURODIVERSITY = "neurodiversity",
  PHYSICAL_DISABILITY = "physical_disability",
  PRISON = "prison",
  TERMINAL_ILLNESS = "terminal_illness",
}
export enum SettableCustomerFlagType {
  CAUTIONARY = "cautionary",
  CUSTOMER_REQUEST = "customer_request",
  FRAUDULENT = "fraudulent",
  IRRESPONSIBLE_LENDING = "irresponsible_lending",
  VULNERABLE = "vulnerable",
}
export enum CreatableTaskType {
  BANK_STATEMENT_PROOF = "bank_statement_proof",
  OPEN_BANKING_REPORT_PROOF = "open_banking_report_proof",
  PAYSLIP_PROOF = "payslip_proof",
  RESIDENCY_PROOF = "residency_proof",
  SELFIE_PROOF = "selfie_proof",
  UNDERWRITER_FINAL_REVIEW = "underwriter_final_review",
  VERBAL_CONFIRMATION = "verbal_confirmation",
}
export enum DetailedRiskAssessmentStatus {
  CANCELLED = "cancelled",
  CHECKS_PASSED = "checks_passed",
  DECLINED = "declined",
  ERRORED = "errored",
  EXPIRED = "expired",
  IN_PROGRESS = "in_progress",
  INTERNAL_ACTION_REQUIRED = "internal_action_required",
  NOT_STARTED = "not_started",
  PASSED = "passed",
  PROOFS_REQUIRED = "proofs_required",
  READY_FOR_FINAL_REVIEW = "ready_for_final_review",
  RUNNING = "running",
  TIMED_OUT = "timed_out",
  WAITING = "waiting",
}
export enum CardApprovalStatus {
  DECLINED = "declined",
  NOT_STARTED = "not_started",
  PROCESSING = "processing",
}
export enum CardStatus {
  APPROVED = "approved",
  DECLINED = "declined",
  DISABLED = "disabled",
  ERRORED = "errored",
  EXPIRED = "expired",
  PENDING_SECURITY_CHECK = "pending_security_check",
  REVOKED = "revoked",
}
export enum JourneyStatus {
  ACCOUNT_CLOSED = "account_closed",
  ACCOUNT_OPEN = "account_open",
  APPLICATION_ACCEPTED = "application_accepted",
  APPLICATION_CANCELLED = "application_cancelled",
  APPLICATION_COMPLETED = "application_completed",
  APPLICATION_DECLINED = "application_declined",
  APPLICATION_EXPIRED = "application_expired",
  APPLICATION_STATUS_UNKNOWN = "application_status_unknown",
  NO_QUOTES = "no_quotes",
  NOT_STARTED = "not_started",
  PENDING_FUNDS_RELEASE = "pending_funds_release",
  QUOTED = "quoted",
  WAITING_FOR_APPLICANT = "waiting_for_applicant",
  WAITING_FOR_E_SIGS = "waiting_for_e_sigs",
  WAITING_FOR_PROOFS = "waiting_for_proofs",
}
export enum ApplicationStatus {
  CANCELLED = "cancelled",
  COMPLETED = "completed",
  DECLINED = "declined",
  EXPIRED = "expired",
  PARTIES_ACCEPTED = "parties_accepted",
  PARTIES_CHECKS_PASSED = "parties_checks_passed",
  PARTIES_CHECKS_RUNNING = "parties_checks_running",
  STARTED = "started",
  WAITING_FOR_PROOFS = "waiting_for_proofs",
}
export enum InProgressApplicationStatus {
  PARTIES_ACCEPTED = "parties_accepted",
  PARTIES_CHECKS_PASSED = "parties_checks_passed",
  PARTIES_CHECKS_RUNNING = "parties_checks_running",
  STARTED = "started",
  WAITING_FOR_PROOFS = "waiting_for_proofs",
}
export enum TerminalApplicationStatus {
  CANCELLED = "cancelled",
  COMPLETED = "completed",
  DECLINED = "declined",
  EXPIRED = "expired",
}
export enum OwnershipCompanyVisibleToCustomer {
  CERBERUS = "cerberus",
  INTRUM = "intrum",
  LANTERN = "lantern",
  LINK = "link",
  TBI = "tbi",
}
export enum MasteredByCompanyVisibleToCustomer {
  EQUINITI = "equiniti",
  LINK = "link",
}
export enum QuoteSearchStatus {
  COMPLETED = "completed",
  ERRORED = "errored",
  PENDING = "pending",
  STARTED = "started",
}
export enum QuoteStatus {
  ACCEPTED = "accepted",
  EXPIRED = "expired",
  NEW = "new",
  SUPPRESSED = "suppressed",
}
export enum PartyStatus {
  ACCEPTED = "accepted",
  CANCELLED = "cancelled",
  CHECKS_PASSED = "checks_passed",
  CHECKS_RUNNING = "checks_running",
  COMPLETED = "completed",
  DECLINED = "declined",
  DETAILS_SET = "details_set",
  NEW = "new",
  OPTED_OUT = "opted_out",
  READY_FOR_CHECKS = "ready_for_checks",
  STARTED = "started",
}
export enum FileStatus {
  COMPLETE = "complete",
  ERRORED = "errored",
  EXPIRED = "expired",
  PENDING = "pending",
}
export enum ApplicationType {
  CONCURRENT = "concurrent",
  NEW = "new",
  REPEAT = "repeat",
  TOP_UP = "top_up",
}
export enum SmartlookEvent {
  APPLICATION_DECLINED = "application_declined",
  BROKER_ARRIVAL = "broker_arrival",
  BROKER_ARRIVAL_CONTINUE = "broker_arrival_continue",
  EDIT_LOAN_APPLICATION = "edit_loan_application",
  ESIGN_ACTIONS_MISSED = "esign_actions_missed",
  ESIGN_COMPLETED = "esign_completed",
  FINANCIALS_PROOF_UPLOAD_ATTEMPTED = "financials_proof_upload_attempted",
  GET_QUOTE = "get_quote",
  GET_QUOTE_ACTIONS_MISSED = "get_quote_actions_missed",
  PROMOTION_APPLIED = "promotion_applied",
  PROOF_TASK_OPENED = "proof_task_opened",
  SPLIT_PAYMENT_FLOW_VISITED = "split_payment_flow_visited",
  SUBMIT_LOAN_APPLICATION = "submit_loan_application",
  SUBMIT_LOAN_APPLICATION_ACTIONS_MISSED = "submit_loan_application_actions_missed",
}
export enum ProductSubClass {
  CONNECT = "connect",
  CORE = "core",
  DEBT_CONSOLIDATION = "debt_consolidation",
}
export enum ProductClass {
  GUARANTOR = "guarantor",
  UNSECURED = "unsecured",
}
export enum PaymentMethod {
  APPLEPAY = "applepay",
  CARD = "card",
  GOOGLEPAY = "googlepay",
  OPEN_BANKING = "open_banking",
}
export enum MalwareScanStatus {
  ACCESS_DENIED = "access_denied",
  FAILED = "failed",
  NO_THREATS_FOUND = "no_threats_found",
  PENDING = "pending",
  SKIPPED = "skipped",
  THREATS_FOUND = "threats_found",
  UNSUPPORTED = "unsupported",
}
export enum FinancialSweepsFileCategory {
  BANKLINE = "bankline",
  BARCLAYS = "barclays",
  CREDORAX = "credorax",
  FDMS = "fdms",
  PAY360 = "pay360",
  TRUELAYER = "truelayer",
}
export enum PaymentAmountOption {
  ARREARS = "arrears",
  CREDIT_ARREARS = "credit_arrears",
  FULL_SETTLEMENT = "full_settlement",
  NEXT_PAYMENT = "next_payment",
  OTHER_AMOUNT = "other_amount",
}
export enum PaymentUsageOption {
  BLANK = "blank",
  EXTRA_PAYMENT = "extra_payment",
  PARTIAL_SETTLEMENT_INSTALMENT = "partial_settlement_instalment",
  PARTIAL_SETTLEMENT_TERM = "partial_settlement_term",
  PAYMENT_PLAN = "payment_plan",
  TOWARDS_ARREARS = "towards_arrears",
}
export enum ProofRejectionStatus {
  CANCELLED = "cancelled",
  DRAFT = "draft",
  REJECTED = "rejected",
}
export enum IncomeSource {
  BENEFITS = "benefits",
  OTHER = "other",
  PARTNERS_INCOME = "partners_income",
  PENSION = "pension",
  RENTAL_INCOME = "rental_income",
  SECOND_JOB = "second_job",
  SELF_EMPLOYED = "self_employed",
}
export enum OpenBankingReportStatus {
  DARWIN_ATTACHMENT_CREATED = "darwin_attachment_created",
  ERRORED = "errored",
  JSON_DOWNLOADED = "json_downloaded",
  PDF_DOWNLOADED = "pdf_downloaded",
  PENDING = "pending",
  READY_FOR_CHECKS = "ready_for_checks",
  WAITING_FOR_CONFIRMATION = "waiting_for_confirmation",
}
export enum OpenBankingLookupStatus {
  AWAITING_REPORT_LOOKUP = "awaiting_report_lookup",
  COMPLETE = "complete",
  ERRORED = "errored",
  EXPIRED = "expired",
}
export enum DebtSolutionProposalType {
  IVA_PROPOSAL = "iva_proposal",
  TRUST_DEED = "trust_deed",
}
export enum DebtSolutionStatus {
  DOCUMENTS_GENERATED = "documents_generated",
  DRAFT = "draft",
  EXTRACTED = "extracted",
  REVIEWED = "reviewed",
}
export enum DebtSolutionVoteOutcome {
  ACCEPT_WITH_FEE_MODIFICATIONS = "accept_with_fee_modifications",
  CLAIM_ONLY = "claim_only",
  REFER_TO_MANAGER = "refer_to_manager",
  REJECT = "reject",
}
export enum DebtSolutionVoteStatus {
  APPROVED = "approved",
  CALCULATED = "calculated",
  OVERRIDDEN = "overridden",
}
export enum DebtSolutionVoteReason {
  FEES_EXCEED_GUIDELINES = "fees_exceed_guidelines",
  FEES_WITHIN_GUIDELINES = "fees_within_guidelines",
  LESS_THAN_3_PAYMENTS = "less_than_3_payments",
  LTPP_ELIGIBLE = "ltpp_eligible",
  REASONABLE_CHANGE_IN_CIRCUMSTANCES = "reasonable_change_in_circumstances",
}
export enum DebtSolutionDocumentStatus {
  EXPIRED = "expired",
  GENERATED = "generated",
}
export enum DebtSolutionDecisionStepKey {
  FEES_EXCEED_GUIDELINES = "fees_exceed_guidelines",
  LTPP_ELIGIBLE = "ltpp_eligible",
  REASONABLE_CHANGE_IN_CIRCUMSTANCES = "reasonable_change_in_circumstances",
  REPAYABLE_WITHIN_TERM = "repayable_within_term",
  THREE_PAYMENTS_MADE = "three_payments_made",
  TOTAL_DEBT_UNDER_THRESHOLD = "total_debt_under_threshold",
}

export enum NextStep {
  COMPLETED = "completed",
  ACCEPTED = "accepted",
  CANCELLED = "cancelled",
  DECLINED = "declined",
  OPTED_OUT = "opted_out",
  MAIN_DETAILS = "main_details",
  CUSTOMER_TASKS_REQUIRED = "customer_tasks_required",
  SCHEDULE_CANCELLED = "schedule_cancelled",
  WITH_FIRST_BANCO = "with_first_banco",
  UNEDITABLE = "uneditable",
  ERROR = "error",
}
export enum Team {
  COMPLAINTS = "Complaints",
  LOYALTY = "Loyalty",
  ORIGINATIONS = "Originations",
  SERVICING = "Servicing",
  UNIDENTIFIED_CUSTOMER = "UnidentifiedCustomer",
  UNDERWRITING = "Underwriting",
}
export enum SmsDeliveryStatus {
  DELIVERED = "delivered",
  ERRORED = "errored",
  NOT_WHITELISTED = "not_whitelisted",
  SEND_DISABLED = "send_disabled",
  SENDING = "sending",
  SENT = "sent",
  TIMED_OUT = "timed_out",
}
export enum ChannelType {
  CHAT = "chat",
  SMS = "sms",
  VOICE = "voice",
  WHATSAPP = "whatsapp",
}
export enum TaskStatusBadgeText {
  PENDING = "Pending",
  IN_REVIEW = "In Review",
  COMPLETED = "Completed",
  NEEDS_ATTENTION = "Needs attention!",
  REQUIRED = "Required",
}
export enum TaskStatusBadgeVariant {
  NONE = "none",
  AWAITING_OTHER_TASKS = "awaiting_other_tasks",
  REQUIRED = "required",
  IN_REVIEW = "in_review",
  COMPLETED = "completed",
  NEEDS_ATTENTION = "needs_attention",
}
export enum DebtConsolidationApplicationStatus {
  NEW = "new",
  SUBMITTED = "submitted",
  IN_PROGRESS = "in_progress",
  FUNDS_EXCEEDED = "funds_exceeded",
  CONFIRMED = "confirmed",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}
export enum DebtConsolidationProvider {
  RE_FI = "ReFi",
}
export enum PaymentFlash {
  PAYMENT_PENDING = "payment_pending",
  PAYMENT_SUCCESSFUL = "payment_successful",
  PAYMENT_SUCCESSFUL_FULL = "payment_successful_full",
  PAYMENT_SUCCESSFUL_NEXT = "payment_successful_next",
  PAYMENT_SUCCESSFUL_PARTIAL_SETTLEMENT = "payment_successful_partial_settlement",
  PAYMENT_DECLINED = "payment_declined",
  PAYMENT_ERRORED = "payment_errored",
}
export enum EmailDirection {
  OUTBOUND = "outbound",
  INBOUND = "inbound",
}
export enum EmailSource {
  ACOUSTIC = "acoustic",
  EXTERNAL = "external",
  FLEXYS = "flexys",
  INTERNAL = "internal",
  TALKDESK = "talkdesk",
}

export enum SmsMissiveCode {
  AD_HOC = "AD_HOC",
  MOBILE_CONFIRMATION = "MOBCONF",
}

export enum DebtType {
  ASSET = "asset",
  BANK = "bank",
  BUY_NOW_PAY_LATER = "buy_now_pay_later",
  CHARGE_CARD = "charge_card",
  CHEQUES = "cheques",
  CML_MEMBER = "cml_member",
  COMMUNICATIONS = "communications",
  CONSOLIDATED_DEBT = "consolidated_debt",
  COURT = "court",
  CREDIT_ACCOUNT = "credit_account",
  CREDIT_CARD = "credit_card",
  CREDIT_SALE = "credit_sale",
  CURRENT_ACCOUNTS = "current_accounts",
  GAMBLING = "gambling",
  HIRE_PURCHASE = "hire_purchase",
  HOME_CREDIT = "home_credit",
  INSURANCE = "insurance",
  LEASE = "lease",
  LIABILITY = "liability",
  LOAN = "loan",
  MAIL_ORDER = "mail_order",
  OTHER = "other",
  OVERDRAFT = "overdraft",
  PAY_DAY_LOAN = "pay_day_loan",
  RENTAL = "rental",
  REVOLVING_ACCOUNT = "revolving_account",
  STORE_CARD = "store_card",
  STUDENT_LOAN = "student_loan",
  SUBSCRIPTION = "subscription",
  TAX = "tax",
  UTILITY = "utility",
  MORTGAGE = "mortgage",
}

export enum DebtCreditCardProvider {
  _118_118 = "118 118",
  AMERICAN_EXPRESS = "American Express",
  AQUA = "Aqua",
  ASDA = "Asda",
  BANK_OF_SCOTLAND = "Bank of Scotland",
  BARCLAYCARD = "Barclaycard",
  CAPITAL_ONE = "Capital One",
  FIRST_DIRECT = "First Direct",
  FLUID = "Fluid",
  HSBC = "HSBC",
  HALIFAX = "Halifax",
  JAJA_FINANCE = "Jaja Finance",
  JOHN_LEWIS = "John Lewis",
  LENDABLE = "Lendable",
  LLOYDS = "Lloyd's",
  MS_BANK = "M&S Bank",
  MBNA = "MBNA",
  MARBLES = "Marbles",
  METRO = "Metro",
  NAT_WEST = "NatWest",
  NATIONWIDE = "Nationwide",
  POST_OFFICE = "Post Office",
  PULSE = "Pulse",
  SAINSBURYS = "Sainsbury's",
  SANTANDER = "Santander",
  TSB = "TSB",
  TESCO = "Tesco",
  THE_AA = "The AA",
  THE_CO_OPERATIVE_BANK = "The Co-operative Bank",
  VANQUIS = "Vanquis",
  VIRGIN_MONEY = "Virgin Money",
  ZOPA = "Zopa",
}

export enum DebtLoanProvider {
  _118_118 = "118 118",
  ABOUND = "Abound",
  ADMIRAL = "Admiral",
  AMOLIFI = "Amolifi",
  ASDA = "Asda",
  BAMBOO = "Bamboo",
  BANK_OF_SCOTLAND = "Bank of Scotland",
  BARCLAYS = "Barclays",
  CASTLE = "Castle",
  CREDIT_SPHERE = "CreditSphere",
  CREDIT_SPRING = "CreditSpring",
  DRAFTY = "Drafty",
  FINIO = "Finio",
  FIRST_DIRECT = "First Direct",
  FLURO = "Fluro",
  HSBC = "HSBC",
  HALIFAX = "Halifax",
  HASTINGS = "Hastings",
  JOHN_LEWIS = "John Lewis",
  LENDABLE = "Lendable",
  LLOYDS = "Lloyd's",
  LOANS_BY_MAL = "Loans by Mal",
  LOANS2_GO = "Loans2Go",
  MS_BANK = "M&S Bank",
  MBNA = "MBNA",
  METRO = "Metro",
  MONZO = "Monzo",
  MY_COMMUNITY_BANK = "My Community Bank",
  NAT_WEST = "NatWest",
  NATIONWIDE = "Nationwide",
  NOVUNA = "Novuna",
  OAKBROOK = "Oakbrook",
  PEOPLES_CHOICE = "People's Choice",
  PLATA = "Plata",
  POST_OFFICE = "Post Office",
  PREMIUM_CREDIT = "Premium Credit",
  REEVO = "Reevo",
  SAINSBURYS = "Sainsbury's",
  SALARY_FINANCE = "Salary Finance",
  SANTANDER = "Santander",
  STARLING = "Starling",
  TANDEM = "Tandem",
  TESCO = "Tesco",
  THE_AA = "The AA",
  THE_CO_OPERATIVE_BANK = "The Co-operative Bank",
  UPDRAFT = "Updraft",
  V12_FINANCE = "V12 Finance",
  VANQUIS = "Vanquis",
  VIRGIN_MONEY = "Virgin Money",
  VODAFONE = "Vodafone",
  ZOPA = "Zopa",
}

export enum DebtStoreCardProvider {
  ARGOS = "Argos",
  DEBENHAMS = "Debenhams",
}

export enum ArrangementType {
  LTPP = "Long Term Payment Plan (LTPP)",
  STPP = "Short Term Payment Plan (STPP)",
}

export enum ProofDocumentProvider {
  OPEN_BANKING_REPORT = "OpenBankingReport",
  JUMIO_TRANSACTION = "JumioTransaction",
  SHARE_CODE = "ShareCode",
  BUREAU_SEARCH = "BureauSearch",
  MANUAL = "Manual",
  CUSTOMER = "Customer",
  ONFIDO_WORKFLOW = "OnfidoWorkflow"
}

export const ProofRejectionReason = {
  "bank_statement": [
    "out_of_date",
    "name_not_showing",
    "no_income_showing",
    "bank_details_not_showing",
    "bank_details_incorrect",
    "address_not_showing",
    "address_incorrect",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "utility_bill": [
    "out_of_date",
    "name_not_showing",
    "address_not_showing",
    "address_incorrect",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "phone_bill": [
    "out_of_date",
    "name_not_showing",
    "address_not_showing",
    "address_incorrect",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "council_bill": [
    "out_of_date",
    "name_not_showing",
    "address_not_showing",
    "address_incorrect",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "payslip": [
    "out_of_date",
    "name_not_showing",
    "employer_differs",
    "employer_not_showing",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "benefits_letter": [
    "out_of_date",
    "name_not_showing",
    "address_not_showing",
    "address_incorrect",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "pension_letter": [
    "out_of_date",
    "name_not_showing",
    "address_not_showing",
    "address_incorrect",
    "blurry_unclear_photo",
    "invalid_format",
    "invalid_document"
  ],
  "open_banking_report": [
    "no_income_showing",
    "bank_details_differ"
  ],
  "driving_licence": [
    "out_of_date",
    "not_valid_id"
  ],
  "passport": [
    "out_of_date",
    "not_valid_id"
  ],
  "id_card": [
    "out_of_date",
    "not_valid_id"
  ],
  "immigration_share_code": [
    "details_dont_match",
    "not_valid_sharecode"
  ],
  "immigration_share_code_doc": [
    "details_dont_match",
    "not_valid_sharecode"
  ],
  "selfie": [
    "selfie_blurry",
    "unacceptable_proof_of_id"
  ],
  "video_selfie": [
    "selfie_blurry",
    "unacceptable_proof_of_id"
  ]
};

export const AddressConfirmationSuccessFlashInfo = "address_confirmation_success";

export const BankConfirmationSuccessFlashInfo = "bank_confirmation_success";

export enum ReasonType {
  CREATE = "create",
  DECLINE = "decline"
}

export const TaskCreateReason = {
  "bank_statement_proof": [
    "Address verification",
    "Bank account verification",
    "Financial vulnerability concerns",
    "Suspected fraud or scam",
    "Income inconsistency",
    "Income verification",
    "Bank does not support open banking",
    "Other",
    "Suspected self-employed"
  ],
  "residency_proof": [
    "Other",
    "Prove residential status"
  ],
  "open_banking_report_proof": [
    "Bank account verification",
    "Financial vulnerability concerns",
    "Income inconsistency",
    "Income verification",
    "Other",
    "Suspected self-employed"
  ],
  "payslip_proof": [
    "Suspected fraud or scam",
    "Income inconsistency",
    "Income verification",
    "Bank does not support open banking",
    "Other",
    "Suspected self-employed"
  ],
  "selfie_proof": [
    "Age appropriate concerns",
    "CIFAS Referral",
    "Suspected fraud or scam",
    "Gender appropriate concerns",
    "Mobile used on third party application",
    "Other",
    "Third party email suspicion"
  ],
  "verbal_confirmation": [
    "Address mismatch",
    "Clarify employment status",
    "Need to clarify income",
    "Confirm application declarations",
    "Confirm loan purpose",
    "Credit inflow refer",
    "Gambling",
    "Other",
    "Returned direct debit refer",
    "Third party email script"
  ],
  "underwriter_final_review": [
    "Other",
    "Vulnerability concerns",
    "Affordability concerns",
    "Suspected fraud or scam"
  ]
};

export const TaskDeclineReason = {
  "Fraud - General": "fraud_general",
  "Fraud – Will not supply supporting documents": "fraud_no_supporting_documents",
  "Fraud - Suspected": "fraud_suspected",
  "Fraud - Suspected Scam": "fraud_suspected_scam",
  "Terms & Conditions – Purpose": "terms_and_conditions_purpose",
  "Terms & Conditions – Contact Information": "terms_and_conditions_contact_information",
  "Terms & Conditions – Income": "terms_and_conditions_income",
  "Terms & Conditions – Existing Loan": "terms_and_conditions_existing_loan",
  "Terms & Conditions – Residency": "terms_and_conditions_residency",
  "Financial vulnerability": "financial_vulnerability",
  "Financial vulnerability - Gambling": "financial_vulnerability_gambling",
  "Capability - Foreign language": "capability_foreign_language",
};

export enum BankValidationTestPanel {
  WAITING_ON_UNDERWRITING = "BankCardValidation-waiting-on-underwiting",
  WAITING_ON_TASKS = "BankCardValidation-waiting-on-tasks",
  CARD_CONFIRMED = "BankCardValidation-card-confirmed",
  ADD_CARD = "BankCardValidation-add-card",
}

export enum TaskProgressTestPanel {
  ALMOST_THERE = "TasksProgress-almost-there",
  IN_REVIEW = "TasksProgress-in-review",
  WAITING = "TasksProgress-waiting",
  DEBT_CONSOLIDATION = "TasksProgress-debt-consolidation",
  DEBT_SELECTION = "TasksProgress-debt-selection",
  ADD_CARD = "TasksProgress-add-card",
  ESIGN_CONTRACT_PROMPT = "TasksProgress-esign-contract-prompt",
  ESIGN_CONTRACT_PROMPT_WRAPPER = "TasksProgress-esign-contract-prompt-wrapper",
  FINAL_REVIEW = "TasksProgress-final-review",
}

/***********************************************
*             PAYMENTS                         *
***********************************************/
export enum PaymentAmountLimit {
  MINIMUM = 1,
  WARNING = 1000
}

export const PaymentPurposes = ["next_payment","arrears","full_settlement","partial_settlement_term","partial_settlement_instalment","payment_plan","extra_payment","towards_arrears"];

export type PaymentPurpose = typeof PaymentPurposes[number];

/***********************************************
*          ACCOUNT_SOLD_CONTACT_INFO           *
***********************************************/

type AccountSoldContactInfo = {
  [K in OwnershipCompanyVisibleToCustomer.TBI | OwnershipCompanyVisibleToCustomer.LANTERN | OwnershipCompanyVisibleToCustomer.LINK | OwnershipCompanyVisibleToCustomer.INTRUM | OwnershipCompanyVisibleToCustomer.CERBERUS]?: {
    display_name: string;
    phone_number: string;
    full_trading_name: string;
    email?: string;
    address?: string;
    managed_by_name?: string;
  };
};

export const ACCOUNT_SOLD_CONTACT_INFO: AccountSoldContactInfo = {
  tbi: {
    display_name: "TBI",
    phone_number: "0118 931 3800",
    full_trading_name: "TBI Financial Services Ltd",
  },
  lantern: {
    display_name: "Lantern",
    phone_number: "0113 887 6876",
    full_trading_name: "Lantern Debt Recovery Services Ltd",
  },
  link: {
    display_name: "Link",
    phone_number: "02920 858 746",
    full_trading_name: "Asset Link Capital (No9) Ltd",
    email: "enquiries@assetlinkcapital.com",
    address: "PO BOX 255, Caerphilly, CF83 9FF",
  },
  intrum: {
    display_name: "Intrum",
    phone_number: "0333 999 7200",
    full_trading_name: "Intrum Investments Designated Activity Company",
    managed_by_name: "Capquest Debt Recovery Limited",
  },
  cerberus: {
    display_name: "Cerberus",
    phone_number: "0333 999 7200",
    full_trading_name: "Promontoria Loki Designated Activity Company",
    managed_by_name: "Capquest Debt Recovery Limited",
  },
};

/***********************************************
*                OPENING HOURS                 *
***********************************************/

export const OPENING_HOURS = {
  mon_fri: {
    open: "9am",
    close: "5pm",
  },
  saturday: {
    open: "9am",
    close: "2pm",
  },
};

/***********************************************
*               PAYOUT                         *
***********************************************/

export enum Payout {
  FINAL_PAYOUT_LOCK_TIME = "3pm"
}

/***********************************************
 *            WORKFLOW TEAMS AND QUEUES        *
 ***********************************************/

export const TEAMS_AND_QUEUES = {
  customer_services: [
    "Updates",
    "New Submits",
    "Call Backs",
    "CSR Manager Reviews",
    "eComms",
    "Chase 1",
    "Chase 2",
    "Chase 3",
    "ESIGS",
    "CSR Ad hoc 1",
    "CSR Ad hoc 2",
    "CSR Ad hoc 3",
  ],
  underwriting: [
    "UW New Submits",
    "Return from CSR",
    "Fraud",
    "UW 1",
    "UW 2",
    "Quick Reviews",
    "UW Ad hoc 1",
    "UW Ad hoc 2",
    "UW Ad hoc 3",
    "UW Manager Reviews",
  ],
};

export const ALERT_BANNER_PAGES = [
  {
    action: "home",
    controller: "banco/website/pages",
    displayName: "Home Page"
  },
  {
    action: "account",
    controller: "banco/website/pages",
    displayName: "Account Summary"
  },
  {
    action: "edit",
    controller: "banco/loan_application_ui/loan_applications",
    displayName: "Application Form"
  },
  {
    action: "show",
    controller: "banco/loan_application_ui/loan_applications",
    displayName: "Customer Task Page"
  },
  {
    action: "show_schedule",
    controller: "banco/website/pages",
    displayName: "Esign"
  },
  {
    action: "show",
    controller: "banco/prismic/static_page",
    displayName: "Prismic Pages"
  },
  {
    action: "welcome",
    controller: "banco/website/welcomes",
    displayName: "Quote Form"
  },
  {
    action: "show",
    controller: "banco/loan_application_ui/quote_searches",
    displayName: "Quote Results Page"
  },
];

/***********************************************
*            CANCELLING REASONS                *
***********************************************/

export const COULD_NOT_PROVIDE = "COULD_NOT_PROVIDE";
export const WILL_NOT_SHARE = "WILL_NOT_SHARE";

export const CUSTOMER_CANCELLING_REASONS = {
  DARWIN_ONLY: {
    "went_with_another_lender": "Went with another lender",
    "application_too_complicated": "Application too complicated/long",
    "wanted_to_update_amount": "Wanted to update amount/term",
    "no_reason_given": "No reason given",
    "duplicate": "Duplicate",
    "card_issues": "Card issues"
  },
  READY_FOR_CHECKS: {
    "cant_send_proofs": "Can't send documents",
    "wont_send_proofs": "Won't share documents"
  },
  ALL: {
    "found_cheaper_lender": "Found cheaper application elsewhere",
    "found_easier_application_lender": "Found easier application elsewhere",
    "no_longer_require_loan": "No longer require a loan",
    "repayments_too_much": "Repayments too much",
    "total_to_repay_too_much": "Total to repay too much",
    "other": "Other"
  },
};

export const DUPLICATE_CANCELLATION_ADDITIONAL_REASONS = {
  TOP_UP_ELIGIBLE: "Top-up eligible",
  DIFFERENT_EMAIL: "Different email used",
  OTHER: "Other",
};

export const IDENTITY_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_selfie_id": "Selfie/ID"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_selfie_id": "Selfie/ID"
  }
};
export const ADDRESS_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_bank_statment": "Bank statement",
    "will_not_share_utility_bill": "Utility bill",
    "will_not_other": "Other"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_bank_statment": "Bank statement",
    "could_not_provide_utility_bill": "Utility bill",
    "could_not_provide_other": "Other"
  }
};
export const VERBAL_CONFIRMATION = {
  "WILL_NOT_SHARE": {
    "will_not_call": "Call"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_call": "Call"
  }
};
export const RESIDENCY_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_residency": "Visa/Residency"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_residency": "Visa/Residency"
  }
};
export const INCOME_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_open_banking": "Open Banking",
    "will_not_share_bank_statment": "Bank statement",
    "will_not_share_payslip": "Payslip",
    "will_not_other": "Other"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_open_banking": "Open Banking",
    "could_not_provide_bank_statment": "Bank statement",
    "could_not_provide_payslip": "Payslip",
    "could_not_provide_other": "Other"
  }
};
export const ENHANCED_INCOME_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_open_banking": "Open Banking"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_open_banking": "Open Banking"
  }
};
export const BANK_ACCOUNT_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_open_banking": "Open Banking",
    "will_not_share_bank_statment": "Bank statement"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_open_banking": "Open Banking",
    "could_not_provide_bank_statment": "Bank statement"
  }
};
export const OPEN_BANKING_REPORT_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_open_banking": "Open Banking"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_open_banking": "Open Banking"
  }
};
export const BANK_STATEMENT_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_bank_statment": "Bank statement"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_bank_statment": "Bank statement"
  }
};
export const PAYSLIP_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_payslip": "Payslip"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_payslip": "Payslip"
  }
};
export const IMMIGRATION_SHARE_CODE_PROOF = {
  "WILL_NOT_SHARE": {
    "will_not_share_immigration_code": "Immigration Share Code"
  },
  "COULD_NOT_PROVIDE": {
    "could_not_provide_immigration_code": "Immigration Share Code"
  }
};

export const EASIER_LENDERS_LIST = {
  "easier_main_bank": "Your main bank",
  "easier_abound": "Abound",
  "easier_admiral": "Admiral",
  "easier_better_borrow": "Better Borrow",
  "easier_finio": "Finio",
  "easier_hastings": "Hastings",
  "easier_lendable": "Lendable",
  "easier_my_community_bank": "My Community Bank",
  "easier_novuna": "Novuna",
  "easier_shawbrook": "Shawbrook",
  "easier_zopa": "Zopa",
  "easier_other": "Other / not listed",
  "easier_do_not_want_to_provide": "Decline to provide"
};
export const CHEAPER_LENDERS_LIST = {
  "cheaper_main_bank": "Your main bank",
  "cheaper_abound": "Abound",
  "cheaper_admiral": "Admiral",
  "cheaper_better_borrow": "Better Borrow",
  "cheaper_finio": "Finio",
  "cheaper_hastings": "Hastings",
  "cheaper_lendable": "Lendable",
  "cheaper_my_community_bank": "My Community Bank",
  "cheaper_novuna": "Novuna",
  "cheaper_shawbrook": "Shawbrook",
  "cheaper_zopa": "Zopa",
  "cheaper_other": "Other / not listed",
  "cheaper_do_not_want_to_provide": "Decline to provide"
};

export const BANCO_ENUM_EMPLOYMENT_STATUS = {
  EMPLOYED_FULL_TIME: "Employed - Full Time",
  EMPLOYED_PART_TIME: "Employed - Part Time",
  EMPLOYED_TEMPORARY: "Employed - Temporary",
  SELF_EMPLOYED: "Self-Employed",
  HOME_MAKER: "Home-maker",
  ON_BENEFITS: "On Benefits",
  RETIRED: "Retired",
  STUDENT: "Student",
  UNEMPLOYED: "Unemployed",
};
export const BANCO_ENUM_PURPOSE = {
  BUSINESS: "Business",
  CAR: "Car",
  DEBT_CONSOLIDATION: "Debt Consolidation",
  EDUCATION: "Education",
  EMERGENCY: "Emergency",
  HOLIDAY: "Holiday",
  HOME_IMPROVEMENT: "Home Improvement",
  OTHER: "Other",
  SPECIAL_PURCHASE: "Special Purchase",
  WEDDING: "Wedding",
};
export const BANCO_ENUM_EMERGENCY_DETAIL = {
  HEATING_REPAIRS: "Heating Repairs",
  HOUSEHOLD_REPAIRS: "Household Repairs",
  CAR_REPAIR: "Car Repair",
  VET_BILL: "Vet Bill",
  MEDICAL_DENTAL_EXPENSES: "Medical/Dental Expenses",
  FUNERAL_EXPENSES: "Funeral Expenses",
  BILLS: "Bills",
  OTHER: "Other",
};
export const BANCO_ENUM_KNOWN_FOR = {
  LESS_THAN_ONE_YEAR: "< 1 Year",
  ONE_TO_THREE_YEARS: "1-3 Years",
  THREE_TO_FIVE_YEARS: "3-5 Years",
  FIVE_OR_MORE_YEARS: "5+ Years",
};
export const BANCO_ENUM_MARITAL_STATUS = {
  CIVIL_PARTNERSHIP: "Civil Partnership",
  DIVORCED: "Divorced",
  LIVING_TOGETHER: "Living Together",
  MARRIED: "Married",
  SEPARATED: "Separated",
  SINGLE: "Single",
  WIDOWED: "Widowed",
};
export const BANCO_ENUM_TITLE = {
  MR: "Mr",
  MRS: "Mrs",
  MISS: "Miss",
  MS: "Ms",
  MX: "Mx",
};
export const BANCO_ENUM_HOUSING_STATUS = {
  HOME_OWNER_WITH_MORTGAGE: "Home Owner with Mortgage",
  HOME_OWNER_WITHOUT_MORTGAGE: "Home Owner without Mortgage",
  LIVE_WITH_PARENTS: "Live With Parents",
  TENANT_FURNISHED: "Tenant Furnished",
  TENANT_UNFURNISHED: "Tenant Unfurnished",
  COUNCIL_TENANT: "Council Tenant",
  OTHER: "Other",
};
export const BANCO_ENUM_INCOME_FREQUENCY = {
  WEEKLY: "Weekly",
  FORTNIGHTLY: "Fortnightly",
  FOUR_WEEKLY: "Four-weekly",
  MONTHLY: "Monthly",
};
export const BANCO_ENUM_RELATIONSHIP = {
  CO_WORKER: "Co-Worker",
  EMPLOYER: "Employer",
  FAMILY_MEMBER: "Family Member",
  FRIEND: "Friend",
  PARTNER: "Partner",
  SPOUSE: "Spouse",
  OTHER: "Other",
};
export const BANCO_ENUM_NATIONALITY = {
  UK_NATIONAL: "UK national",
  EUROPEAN_UNION_NATIONAL: "European Union national",
  OTHER_NATIONALITY: "Other",
};
export const BANCO_ENUM_DECLARATIONS_VISA = {
  YES: "Yes",
  NO: "No",
};
export const BANCO_ENUM_DECLARATIONS_EXPECTED_CHANGE_IN_FINANCIAL_SITUATION = {
  YES: "Yes",
  NO: "No",
};
export const BANCO_ENUM_DECLARATIONS_PLAN_TO_RETIRE = {
  YES: "Yes",
  NO: "No",
};
export const BANCO_ENUM_DECLARATIONS_PLAN_TO_REDUCE_WORKING_HOURS = {
  YES: "Yes",
  NO: "No",
};
export const BANCO_ENUM_TIME_AT = {
  LESS_THAN_TWELVE_MONTHS: "< 12 Months",
  TWELVE_TO_EIGHTEEN_MONTHS: "12-18 Months",
  NINETEEN_TO_TWENTYFOUR_MONTHS: "19-24 Months",
  TWENTYFIVE_TO_THIRTY_MONTHS: "25-30 Months",
  THIRTYONE_TO_THIRTYFIVE_MONTHS: "31-35 Months",
  THIRTYSIX_OR_MORE_MONTHS: "36+ Months",
};
export const BANCO_ENUM_NUMBER_DEPENDANTS = {
  ZERO: "0",
  ONE: "1",
  TWO: "2",
  THREE: "3",
  FOUR: "4",
  FIVE: "5",
  SIX: "6",
  SEVEN: "7",
  EIGHT: "8",
  NINE: "9",
  TEN: "10",
};
export const BANCO_ENUM_TOP_UP_SOURCES = {
  INBOUND: "Inbound",
  OUTBOUND: "Outbound",
  RETENTIONS: "Retentions",
};
export const BANCO_ENUM_SOURCE_OF_FUNDS = {
  FUNDS_FROM_NEW_LOAN: "Funds from a new loan",
  FAMILY_OR_FRIENDS: "Support from family or friends",
  SAVINGS: "Personal savings",
  INCOME: "Regular income",
  BONUS: "Bonus from work",
  CREDIT_ARREARS: "Credit arrears",
  OTHER: "Other",
};
export const BANCO_ENUM_FUNDS_FROM_NEW_LOAN = {
  ABOUND: "Abound",
  ADMIRAL: "Admiral",
  BETTER_BORROW: "Better Borrow",
  FINIO: "Finio",
  HASTINGS: "Hastings",
  LENDABLE: "Lendable",
  MY_COMMUNITY_BANK: "My Community Bank",
  NOVUNA: "Novuna",
  SHAWBROOK: "Shawbrook",
  ZOPA: "Zopa",
  COMMUNITY_FINANCE: "Community Finance",
  NATWEST: "Natwest",
  TESCO_LOANS: "Tesco Loans",
  MONZO: "Monzo",
  ASDA: "Asda",
  MBNA: "MBNA",
  BARCLAYS: "Barclays",
  LLOYDS: "Lloyds",
  UPDRAFT: "Updraft",
  M_AND_S: "M&S",
  TANDEM: "Tandem",
  HSBC: "HSBC",
  PLATA: "Plata",
  FLURO_FINANCE: "Fluro Finance",
  OAKBROOK_LOANS: "Oakbrook Loans",
  SALARY_FINANCE: "Salary Finance",
  CREATION_FINANCE: "Creation Finance",
  SELINA_FINANCE: "Selina Finance",
  EVERYDAY_LOANS: "Everyday Loans",
  HALIFAX: "Halifax",
  ONE_ONE_EIGHT_ONE_ONE_EIGHT: "118118",
  EVLO: "Evlo",
  JOHN_LEWIS: "John Lewis",
  SANTANDER: "Santander",
  CASTLE_COMMUNITY_BANK: "Castle Community Bank",
  TSB: "TSB",
  BAMBOO: "Bamboo",
  RBS: "RBS",
  DEBT_CONSOLIDATION: "Debt Consolidation",
  FIRST_DIRECT: "First Direct",
  REEVO: "Reevo",
  PEPPER_MONEY: "Pepper Money",
  EVOLUTION: "Evolution",
  CO_OP: "Co-op",
  UNITED_TRUST_BANK: "United Trust Bank",
  ROYAL_BANK_OF_SCOTLAND: "Royal Bank of Scotland",
  MALLARD_LOANS: "Mallard Loans",
  EQUIFINANCE: "Equifinance",
  TRANSAVE: "Transave",
  COPPERPOT: "Copperpot",
  INTERBRIDGE_MORTGAGES: "Interbridge Mortgages",
  LENDING_WORKS: "Lending Works",
  PLEND: "Plend",
  COMMUNITY_BANK: "Community Bank",
  CREDIT_SPRING: "Credit Spring",
  NORWICH: "Norwich",
  PLANE_SAVER: "Plane Saver",
  STEP_ONE: "Step One",
  ACCORD: "Accord",
  SAVVI_CREDIT_UNION: "Savvi Credit Union",
  WAGESTREAM: "Wagestream",
  SERVE_AND_PROTECT: "Serve and Protect",
};
export const BANCO_ENUM_FUNDS_FROM_NEW_LOAN_REASONS = {
  LOWER_INTEREST: "Lower interest rates",
  LOWER_REPAYMENTS: "Lower monthly repayments",
  DEBT_CONSOLIDATION: "To consolidate multiple debts",
  OTHER: "Other",
};
export const BANCO_ENUM_TIME_AT_CONSIDER_AS = {
  LESS_THAN_TWELVE_MONTHS: "11",
  TWELVE_TO_EIGHTEEN_MONTHS: "18",
  NINETEEN_TO_TWENTYFOUR_MONTHS: "24",
  TWENTYFIVE_TO_THIRTY_MONTHS: "30",
  THIRTYONE_TO_THIRTYFIVE_MONTHS: "35",
  THIRTYSIX_OR_MORE_MONTHS: "36",
};

export const TEST_POSTCODE = "ID1 1QD";
export const MAX_MONTHLY_MORTGAGE_OR_RENT = 20000;
export const MAX_MONTHLY_EXPENDITURE = 50000;
export const MAX_OTHER_MONTHLY_INCOME = 5000;
export const MINIMUM_APPLICANT_AGE = 18;
export const MINIMUM_MONTHLY_APPLICANT_INCOME = 1200;

export const REGEX_MOBILE = /^(0|(\+?44))\s*(\(0\))?\s*7(\s*\d\s*){9}$/;
export const REGEX_RESIDENTIAL_PHONE = /^(0|(\+?44\s*(\(0\))?\s*))+(((1[0-9]{3})|(7[1-9]{1}[0-9]{2})|(20)( )?[7-8]{1})( )?([0-9]{2,3}[ \-]?[0-9]{3})|(2[0-9]{2}( )?[0-9]{3}[ \-]?[0-9]{4}))$/;
export const REGEX_UK_PHONE = /^(((\+|00)?44|0)([123578]{1}))(((\d{1}\s?\d{4}|\d{2}\s?\d{3})\s?\d{4})|(\d{3}\s?\d{2,3}\s?\d{3})|(\d{4}\s?\d{4,5}))$/;
export const REGEX_ADDRESS_BUILDING_NUMBER = /^[A-Za-z '\-.&0-9\/\\]{1,12}$/;
export const REGEX_ADDRESS_SUB_BUILDING_NAME = /^[A-Za-z '\-.&0-9\/\\]{1,30}$/;
export const REGEX_ADDRESS_BUILDING_NAME = /^[A-Za-z '\-.&0-9]{1,50}$/;
export const REGEX_ADDRESS_THOROUGHFARE = /^[A-Za-z '\-.&0-9]{1,50}$/;
export const REGEX_ADDRESS_TOWN = /^[A-Za-z '\-.&0-9]{1,25}$/;
export const REGEX_POSTCODE = /^(GIR ?0AA|X[A-Z0-9 ]*|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9][0-9ABEHMNPRV-Y]?)|[0-9][A-HJKPS-UW]) ?[0-9][ABD-HJLNP-UW-Z]{2})$/;
export const REGEX_ILLEGAL_POSTCODE = /^(AI-2640|ASCN1ZZ|BBND1ZZ|BIQQ1ZZ|FIQQ1ZZ|FIQQ122|GX111AA|PCRN1ZZ|PCRN122|SIQQ1ZZ|SIQQ122|STHL1ZZ|STHL122|TDCU1ZZ|TDCU122|TKCA1ZZ|TKCA122|BS981TL|BX11LT|BX32BB|BX55AT|CF101BH|CF991NA|DE993GG|DH981BT|DH991NS|E161XL|N19GU|E981NW|E981SN|E981ST|E981TT|EC2N2DB|EC4Y0HQ|EH991SP|G581SB|GIR0AA|IV212LR|L304GB|LS981FD|N811ER|NW14JT|SE18UJ|SE92UG|SN381NW|SW1A0PW|SW1W0DT|W1D4FA|W1J5UB|NN179RS|W1N4DJ|W1A1EX|GY|JE|IM|AC|ASCN|BIQQ|BBND|PN|SH|GS|TC)[A-Z0-9 ]*$/;
export const REGEX_NAME = /^(?=[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð '\-]*[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð])[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð '\-]{2,}$/;
export const REGEX_NAME_INCLUDING_NUMBERS_AT_END = /^(?=[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð '\-]*[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð])[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð '\-]{2,}\d{0,4}$/;
export const REGEX_EMAIL_ADDRESS = /^[!#$%&'*+\-.\/0123456789=?ABCDEFGHIJKLMNOPQRSTUVWXYZ\^_`abcdefghijklmnopqrstuvwxyz{|}~]+@([\-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ\[\]_abcdefghijklmnopqrstuvwxyz]+\.)+[\-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ\[\]_abcdefghijklmnopqrstuvwxyz]+$/;
export const REGEX_NATIONAL_INSURANCE_NUMBER = /^(?![A-Z]?[DFIQUV]|[A-Z]O|BG|GB|KN|NK|NT|TN|ZZ)[A-Z]{2}\d{6}[A-D]$/;
export const REGEX_TESTING_NATIONAL_INSURANCE_NUMBER = /^(?![A-Z]?[DFIUV]|[A-Z]O|BG|GB|KN|NK|NT|TN|ZZ)[A-Z]{2}\d{6}[A-D]$/;
export const REGEX_BANK_SORT_CODE = /^(\d){2}-(\d){2}-(\d){2}$/;
export const REGEX_BANK_ACCOUNT_NUMBER = /^(\d){8}$/;

export const CO_OP_THEME_ID = "co-op-theme";
export const BUDGET_THEME_ID = "budget-theme";

export const ErrorMessage = {
  CUSTOMER_ID_REQUIRED_QUOTE_SEARCH_MSG: "customer_id is required for a logged in customer",
};

export const Partner = {
  budget: "budget",
  co_op: "co-op",
} as const;

export type Partner = typeof Partner[keyof typeof Partner];

export const DEFAULT_PRODUCT_TENURES = [12,18,24,30,36,42,48,54,60,66,72,78,84];
export const MIN_LOAN_VALUE = 1000;
export const MAX_LOAN_VALUE = 35000;

export const DEFAULT_OPENING_HOURS_BY_TEAM_AND_CHANNEL = {
  [Team.SERVICING]: {
    [ChannelType.CHAT]: {
      Monday: ["08:00", "16:00"],
      Tuesday: ["08:00", "16:00"],
      Wednesday: ["08:00", "16:00"],
      Thursday: ["08:00", "16:00"],
      Friday: ["09:00", "16:00"],
    },
    [ChannelType.VOICE]: {
      Monday: ["08:00", "18:00"],
      Tuesday: ["08:00", "18:00"],
      Wednesday: ["08:00", "18:00"],
      Thursday: ["08:00", "18:00"],
      Friday: ["09:00", "17:00"],
      Saturday: ["09:00", "14:00"],
    },
  },
  [Team.ORIGINATIONS]: {
    [ChannelType.CHAT]: {
      Monday: ["10:00", "17:00"],
      Tuesday: ["09:00", "17:00"],
      Wednesday: ["09:00", "17:00"],
      Thursday: ["09:00", "17:00"],
      Friday: ["09:00", "17:00"],
    },
    [ChannelType.VOICE]: {
      Monday: ["09:00", "17:00"],
      Tuesday: ["09:00", "17:00"],
      Wednesday: ["09:00", "17:00"],
      Thursday: ["09:00", "17:00"],
      Friday: ["09:00", "17:00"],
      Saturday: ["09:00", "14:00"],
    },
  },
  [Team.LOYALTY]: {
    [ChannelType.CHAT]: {
      Monday: ["10:00", "17:00"],
      Tuesday: ["09:00", "17:00"],
      Wednesday: ["09:00", "17:00"],
      Thursday: ["09:00", "17:00"],
      Friday: ["09:00", "17:00"],
    },
    [ChannelType.VOICE]: {
      Monday: ["09:00", "17:00"],
      Tuesday: ["09:00", "17:00"],
      Wednesday: ["09:00", "17:00"],
      Thursday: ["09:00", "17:00"],
      Friday: ["09:00", "17:00"],
      Saturday: ["09:00", "14:00"],
    },
  },
  [Team.UNDERWRITING]: {
    [ChannelType.VOICE]: {
      Monday: ["09:00", "17:00"],
      Tuesday: ["09:00", "17:00"],
      Wednesday: ["09:00", "17:00"],
      Thursday: ["09:00", "17:00"],
      Friday: ["09:00", "17:00"],
    },
  },
  [Team.COMPLAINTS]: {
    [ChannelType.VOICE]: {
      Monday: ["09:00", "17:00"],
      Tuesday: ["09:00", "17:00"],
      Wednesday: ["09:00", "17:00"],
      Thursday: ["09:00", "17:00"],
      Friday: ["09:00", "17:00"],
    },
  },
};

export const QUEUE_PROCESSING_DELAY_MS = 2000;
export const RESOURCE_UPDATED_ON_SERVER = "resource_updated_on_server";
export const RESOURCES_UPDATED_ON_SERVER = "resources_updated_on_server";
export const RESOURCES_UPDATED_ON_SERVER_URGENT = "resources_updated_on_server_urgent";
export const TEAMS = ["customer_services","underwriting"];
export const QUEUES = ["Assigned Away","Call Backs","CSR Ad hoc 1","CSR Ad hoc 2","CSR Ad hoc 3","CSR Manager Reviews","Chase 1","Chase 2","Chase 3","eComms","ESIGS","New Submits","Updates","Fraud","Return from CSR","UW Ad hoc 1","UW Ad hoc 2","UW Ad hoc 3","UW Manager Reviews","UW New Submits","UW 1","UW 2","Quick Reviews"];
export const CSR_QUEUES = ["Assigned Away","Call Backs","CSR Ad hoc 1","CSR Ad hoc 2","CSR Ad hoc 3","CSR Manager Reviews","Chase 1","Chase 2","Chase 3","eComms","ESIGS","New Submits","Updates"];
export const UNDERWRITING_QUEUES = ["Fraud","Return from CSR","UW Ad hoc 1","UW Ad hoc 2","UW Ad hoc 3","UW Manager Reviews","UW New Submits","UW 1","UW 2","Quick Reviews"];
export const UNDERWRITING_TEAM = "underwriting";
export const CUSTOMER_SERVICE_TEAM = "customer_services";

export const ALLOWED_ADHOC_SEARCH_TYPES = ["CallReportBSBSearch"];

export enum BureauSearchTemporality {
  CURRENT = "current",
  PREVIOUS = "previous",
}

export const CONTACT_US_LINK_PLACEHOLDER = "{ contact_us_link }";

/***********************************************
*               SETTLEMENTS                    *
***********************************************/

export const PARTIAL_SETTLEMENT_AMOUNT_ERROR_CODE = "partial_settlement_amount_invalid";

/***********************************************
*            CONTACT_PREFERENCES               *
***********************************************/

export enum ContactPreferenceCategories {
  MARKETING = "marketing",
  MARKETING_1 = "marketing_1",
}

export enum ContactPreferenceVectors {
  EMAIL = "email",
  SMS = "sms",
}

/***********************************************
*            SUPPORT                           *
***********************************************/

export enum Format {
  XML = "xml",
  JSON = "json",
}
